// src/auth/registered/SEC_07_00_TrustContext.jsx
import React, { createContext, useContext, useState, useEffect } from 'react';
import { useSecurity } from "./SEC_03_03_SecurityContext"; 

const TrustContext = createContext();

export const TrustProvider = ({ children }) => {
    const { user } = useSecurity();
    const [trustLevel, setTrustLevel] = useState(null); // NULL = Uninitialized
    const [isChecking, setIsChecking] = useState(false);

    // This is the "Lazy" trigger called by sensitive controls
    const verifyTrust = async () => {
        if (trustLevel !== null || !user?.SiteUserGuid) return;
        
        setIsChecking(true);
        try {
            // Simulated API call to [nrgpi_sportgramme] using user.SiteUserGuid
            // If the site doesn't use Trust, the API should return 'TRUSTED' by default
            const response = await fetch(`/api/security/trust/${user.SiteUserGuid}`);
            const data = await response.json();
            setTrustLevel(data.level || 'TRUSTED'); 
        } catch (error) {
            console.warn("Trust check failed, defaulting to TRUSTED to avoid breaking site.");
            setTrustLevel('TRUSTED');
        } finally {
            setIsChecking(false);
        }
    };

    return (
        <TrustContext.Provider value={{ trustLevel, isChecking, verifyTrust }}>
            {children}
        </TrustContext.Provider>
    );
};

export const useTrust = () => useContext(TrustContext);